module.exports = "<aside class=\"al-sidebar\" sidebarResize>\n\n  <ba-menu [menuHeight]=\"menuHeight\"\n           [sidebarCollapsed]=\"isMenuCollapsed\"\n           (expandMenu)=\"menuExpand()\"\n           (menupdated)=\"onMenuUpdated($event)\">\n  </ba-menu>\n  <div *ngIf=\"!isMenuCollapsed\" style=\"font-family: 'Montserrat', sans-serif;font-size: 11px;color: white;padding: 5px;text-align: center\">\n    <div>remoteEye IoT Platform </div>\n    <div>2023 &copy; SpaceAge Labs</div>\n  </div>\n          \n</aside>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/theme/components/baSidebar/baSidebar.html
// module id = ./src/app/theme/components/baSidebar/baSidebar.html
// module chunks = main